module.exports = __webpack_public_path__ + "static/media/search.68648000.jpg";